@if (lorenzFormGroup) {

	<!--	<div class="debug"> | {{ lorenzFormGroup.getPath() }} | {{ lorenzFormGroup.getKey() }} | {{ lorenzFormGroup.getText() }}</div>-->

	@if (hasGroupHeaders || lorenzFormGroup.getText()) {

		@if (lorenzFormGroup.getLabel() + getListSuffix() || lorenzFormGroup.getText()) {

			<div class="group-head">

				@if (hasGroupHeaders) {

					@if (lorenzFormGroup.getLabel() + getListSuffix()) {
						<div class="group-title">

							<div class="group-title-text"
								 [innerHTML]="(lorenzFormGroup.getLabel() | translate) + getListSuffix() + lorenzFormGroup.getRequiredAsterisk() ">
							</div>

							@if (hasActionButton) {

								<div class="group-title-actions">

									@if (isListItem && hasDeleteButton) {

										<button mat-icon-button class="mat-action-delete "
												title="{{ 'Position löschen' | translate }}"
												[disabled]="deleteButtonDisabled"
												(click)="deleteListItem()">
											<mat-icon>delete</mat-icon>
										</button>

									}

									@if (hasSaveButton) {

										@if (showPartnerSaveTextButton) {
											<button mat-flat-button
													class="mat-action-save mat-action-save-text"
													title="{{ 'Eingaben speichern' | translate }}"
													[disabled]="saveButtonDisabled"
													(click)="callStoreRequestFn()">
												<mat-icon>save</mat-icon>
												<span>Speichern</span>
											</button>
										} @else {
											<button mat-icon-button class="mat-action-save"
													title="{{ 'Eingaben speichern' | translate }}"
													[disabled]="saveButtonDisabled"
													(click)="callStoreRequestFn()">
												<mat-icon>save</mat-icon>
											</button>
										}

									}

								</div>

							}

							@if (isExpandable && expandCheckboxControl) {
								<lib-form-control-checkbox [control]="expandCheckboxControl"
														   [isGroupCheck]="true"></lib-form-control-checkbox>
							}

						</div>
					}

				}

				@if (lorenzFormGroup.getText()) {
					<div class="group-text"
						 [innerHTML]="lorenzFormGroup.getText() | translate">
					</div>

				}

			</div>

		}

	}

	<lib-form-validity-dot [control]="lorenzFormGroup" />

	@if (lorenzFormGroup.isVisible()) {

		<div class="group-content"
			 [ngClass]="{'highlighted': lorenzFormGroup.getControl('checked')?.isHighlighted()}">

			@for (control of lorenzFormChildren; track $index) {

				@if (control.isVisible()) {

					@if (control.getLorenzFormTypeString() === 'LorenzFormControl') {

						@if (control.getDirection() === 'row') {

							@if (!isLayoutFloatingLabels) {
								<div class="label"
									 [ngClass]="{'row': control.getDirection() === 'row'}"
									 [class.missing-required]="control.isMissingRequiredValue()"
									 [innerHTML]="(control.getLabel() | translate) + control.getRequiredAsterisk()">
								</div>
							}

							<ng-container *ngTemplateOutlet="formSwitch; context:{ control: control, options: lorenzFormComponentOptions }"></ng-container>

						} @else {

							@if (!isLayoutFloatingLabels && control.getLabel()) {

								<div class="label"
									 [class.missing-required]="control.isMissingRequiredValue()"
									 [innerHTML]="(control.getLabel() | translate) + control.getRequiredAsterisk()">
								</div>

							}

							<ng-container *ngTemplateOutlet="formSwitch; context:{ control: control, options: lorenzFormComponentOptions }"></ng-container>

						}

					} @else {

						<ng-container *ngTemplateOutlet="formSwitch; context:{ control: control, options: lorenzFormComponentOptions }"></ng-container>

					}

				}

			}

		</div>

	}

	<ng-content></ng-content>

}

<ng-template #formSwitch let-control="control" let-layout="layout">

	@switch (control.getLorenzFormTypeString()) {

		@case ('LorenzFormGroup') {

			<lib-form-component-group [group]="control"
									  [options]="lorenzFormComponentOptions"></lib-form-component-group>
		}
		@case ('LorenzFormList') {
			<lib-form-component-list [list]="control"
									 [options]="lorenzFormComponentOptions"></lib-form-component-list>
		}
		@default {
			<lib-form-component-control [control]="control"
										[options]="lorenzFormComponentOptions"></lib-form-component-control>
		}
	}

</ng-template>
